import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  /info/tarneaeg\_ja\_transport

  <span style="color:#85c1dc;">**FI:**</span>
  /info/toimitusaika\_ja\_kuljetus

  <span style="color:#85c1dc;">**RU:**</span>
  /info/srok\_postavki\_i\_transport
*/
/* @__NO_SIDE_EFFECTS__ */
const m1682 = msg(
  mf`/info/tarneaeg_ja_transport`,
  mf`/info/toimitusaika_ja_kuljetus`,
  mf`/info/srok_postavki_i_transport`,
)

export { m1682 as 'link.transport.href' }